module.exports = __webpack_public_path__ + "static/media/4650.157acc92.jpg";